module.exports = __webpack_public_path__ + "static/media/sumeet_barhona6.c84e5352.jpg";